import { doc, onSnapshot, type Unsubscribe } from 'firebase/firestore';
import { db } from '@/lib/firebase';
import { useSubscriptionStore, type Subscription } from '@/stores/subscriptionStore';
import { toOptionalDate } from './firestoreDate';
import { logSyncError } from './syncErrors';

function subscriptionDoc(uid: string) {
  return doc(db, 'users', uid, 'subscription', 'main');
}

export function startSubscriptionSync(uid: string): Unsubscribe {
  return onSnapshot(
    subscriptionDoc(uid),
    (snap) => {
      if (!snap.exists()) {
        useSubscriptionStore.getState().setSubscription({
          tier: 'free',
          expiresAt: null,
          willRenew: false,
          provider: null,
          productId: null,
          managementUrl: null,
          billingIssue: false,
        });
        return;
      }
      const data = snap.data();
      const subscription: Subscription = {
        tier: (data.tier as 'free' | 'pro') ?? 'free',
        expiresAt: toOptionalDate(data.expiresAt) ?? null,
        willRenew: (data.willRenew as boolean) ?? false,
        provider: (data.provider as 'apple' | 'stripe') ?? null,
        productId: (data.productId as string) ?? null,
        managementUrl: (data.managementUrl as string) ?? null,
        billingIssue: (data.billingIssue as boolean) ?? false,
      };
      useSubscriptionStore.getState().setSubscription(subscription);
    },
    logSyncError('subscriptionSync', uid),
  );
}
